import React, { useEffect } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import api from "../../../api";
import { useDispatch, useSelector } from "react-redux";
import {
  closeAddEmployeeBankDetail,
  closeEmployeeBankDetail,
  fetchEmployeeBankDetails,
  openAddEmployeeBankDetail,
  openEmployeeBankDetail,
} from "./store/employeeBankDetailsSlice";
import EmployeeBankDetailsDataTable from "./EmployeeBankDetailsDataTable";
import AddEmployeeBankDetails from "./AddEmployeeBankDetails";
import AddEditEmployeeBankDetail from "./AddEditEmployeeBankDetail";
import { toast } from "react-toastify";


const EmployeeBankDetails = () => {
  const dispatch = useDispatch();
  const {
    data = [],
    loading = false,
    isModalOpen = false,
    isAddModalOpen = false,
  } = useSelector((state) => state.employeeBankDetailData || {});

  useEffect(() => {
    dispatch(fetchEmployeeBankDetails());
  }, [dispatch]);

  const handleAddClick = () => {
    dispatch(openAddEmployeeBankDetail());
  };

  const handleImportClick = () => {
    dispatch(openEmployeeBankDetail());
  };

  const handleDownload = async () => {
    const formData = new FormData();
    formData.append("file_name", "bank_details"); // Ensure the correct file_name is passed
  
    try {
      const response = await api.post("/download-sample-file", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        responseType: "blob", // Receive response as binary data
      });
  
      // Create a Blob from the response data
      const blob = new Blob([response.data], { type: "text/csv" });
  
      // Create a link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
  
      // Set the download attribute with a filename
      link.download = "sample_bank_details.csv";
  
      // Append to the document and trigger download
      document.body.appendChild(link);
      link.click();
  
      // Remove the link element after download
      document.body.removeChild(link);
      toast.success("File downloaded successfully!");
  
    } catch (error) {
      console.error(error);
      toast.error("Failed to Download. Please try again.");
    } finally {
      // Cleanup or additional actions
      console.log("Download attempt completed.");
    }
  };
  

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Employee Bank Details"
            title="Dashboard"
            subtitle="Employee Bank Details"
            actions={[
              {
                label: "Add",
                onClick: handleAddClick,
                className: "btn btn-primary me-2",
              },
              {
                label: "Import",
                onClick: handleImportClick,
                className: "btn btn-secondary me-2",
              },
              {
                label: "Dowanload Sample File",
                onClick: handleDownload,
                className: "btn btn-success",
              },
            ]}
          />

          <EmployeeBankDetailsDataTable data={data} loading={loading} />

          <AddEmployeeBankDetails
            show={isModalOpen}
            onClose={() => dispatch(closeEmployeeBankDetail())}
          />

          <AddEditEmployeeBankDetail
            show={isAddModalOpen}
            onClose={() => dispatch(closeAddEmployeeBankDetail())}
          />
        </div>
      </div>
    </div>
  );
};

export default EmployeeBankDetails;
